/// <amd-module name="Favorites/Common/Contracts/Service" />
import { Favorite } from "Favorites/Common/Contracts/Favorite";
import { IVssService } from "VSS/Platform/Context";

/**
 * Service interface to provide associated data for a favorite provider, that can be used to customized rendering of the favorite. 
 */
export interface IFavoriteProviderDataService extends IVssService {
	/**
	* Return the artifact type associated with this provider
	*/  
	getArtifactType: () => string;

	/**
	* Get a custom display name for the favorite. If one isnt provided the artifact name is used. 
	*/    
	getDisplayName?: (favorite: Favorite) => string;

	/**
	* Get the tooltip text to display for the favorite on hover. If one isnt provided the name of the artifact scope is displayed. 
	*/ 
	getToolTipOnHover?: (favorite: Favorite)  => string;
}